import React from "react";
import "../../../styles/main.css";
import theme from "../../../styles/theme";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import Subpage_104 from "../../../modules/caneva/Subpage_104";



const Page_104 = () => {
  return (

 <div style={{ padding: 0 , margin:0 }}>
      <Breadcrumb
        items={[
          { label: "homepage", href: "/HomePage" },
          { label: "caneva / specifications", href: "/page_104" },
        ]}
      />
      {/* <PageHeader
        title=""
        // subtitle="Gérez les spécifications de votre projet"
        className= "title-caneva"
      /> */}
      {/* <hr className="page-separator" /> */}
      {/* Contenu principal */}
      <main className="content" style={{ padding: 0, margin:0 , background:"transparent"}}>
        <div style={{ padding: 0 , margin:0}}>
          <Subpage_104 />
        </div>
      </main>
      
    </div>

  );
};

export default Page_104;
